import { useEffect, useState } from "react";

interface Params {
  /** Fecha objetivo en ms (Date.now() basis). Null = sin countdown corriendo. */
  deadline: number | null;
  /** Callback cuando llega a 0. */
  onExpired?: () => void;
}

/**
 * Countdown que tickea cada 1s.
 * Devuelve segundos restantes (clampeado a >= 0) y un flag isExpired.
 */
export function useCountdown({ deadline, onExpired }: Params) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (deadline == null) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [deadline]);

  const remainingMs = deadline == null ? null : Math.max(0, deadline - now);
  const remainingSec = remainingMs == null ? null : Math.floor(remainingMs / 1000);
  const isExpired = remainingMs != null && remainingMs <= 0;

  useEffect(() => {
    if (isExpired) onExpired?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExpired]);

  return { remainingSec, isExpired };
}

export function formatCountdown(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}
